package kz.dentalcrm.app.data.network.response_model.protocol_templates

import kotlinx.serialization.Serializable

@Serializable
class ProtocolResponse(
    val data: ProtocolPaginatedData? = null
)

@Serializable
class ProtocolPaginatedData(
    val data: List<ProtocolTemplate>? = null,
    val current_page: Int? = null,
    val last_page: Int? = null,
    val per_page: Int? = null,
    val total: Int? = null
)
